<script setup>
/**
 * OfferShownReporter — renders nothing; reports that the Inventory-beta offer
 * became visible.
 *
 * A component rather than a composable because "was it shown" is a question
 * about a piece of MARKUP, and the answer differs per surface: a dropdown row
 * is shown when its menu opens, a sidebar card when the sidebar is expanded, a
 * modal when it is open. Each entry point passes its own `shown` expression,
 * and the reporting rule — once per dealer, first surface wins — stays in one
 * place instead of being re-derived at four call sites.
 *
 * `markBetaOfferShown` is itself idempotent (server-persisted flag + an
 * in-flight guard), so several of these mounting at once is safe.
 *
 *   <OfferShownReporter :shown="open && !isNewDesign" :surface="SURFACES.AVATAR_MENU" />
 */
import { watch } from 'vue'
import { useNewDesign } from '@/hooks/useNewDesign'
import { INVENTORY_BETA_SURFACES } from '@/constants'

const props = defineProps({
  /** Is the offer on screen right now? */
  shown: { type: Boolean, default: false },
  /** Which entry point — a value from `INVENTORY_BETA_SURFACES`. */
  surface: { type: String, default: INVENTORY_BETA_SURFACES.UNKNOWN },
})

const { markBetaOfferShown } = useNewDesign()

// `immediate`, because a surface that is visible the moment it mounts (the
// sidebar promo, the welcome modal) never transitions false → true.
watch(() => props.shown, (shown) => {
  if (shown) markBetaOfferShown(props.surface)
}, { immediate: true })
</script>

<template><!-- reporting only --></template>
